import { SortConfig } from '@brainpool/components/organisms/Table/Table';

export interface ColumnProps {
  id: string;
  label: string;
  display: boolean;
  order: number;
}
export const defaultSortConfig: SortConfig = {
  field: 'dateCreated',
  order: 'desc',
};

export const completedStatuses = [
  'screener_completed',
  'duediligence_completed',
  'report_completed',
  'report_started',
  'report_error',
];
export const defaultColumns: ColumnProps[] = [
  { id: 'sector', label: 'Sector', display: true, order: 0 },
  { id: 'fitScore', label: 'Fit Score', display: true, order: 1 },
  { id: 'ups', label: 'USP', display: true, order: 2 },
  { id: 'tech', label: 'Tech', display: true, order: 3 },
  { id: 'patents', label: 'Patents', display: true, order: 4 },
  { id: 'team', label: 'Team', display: true, order: 5 },
  { id: 'dataCoverage', label: 'Data Coverage', display: true, order: 6 },
  { id: 'risks', label: 'Risks', display: true, order: 7 },
];
export type ColumnId =
  | 'sector'
  | 'fitScore'
  | 'ups'
  | 'tech'
  | 'patents'
  | 'team'
  | 'dataCoverage'
  | 'risks';
